import React, { useEffect } from 'react';
import { DropTarget } from 'react-dnd';

const target = {
    drop(props, monitor) {
        let { elements } = monitor.getItem();
        let { elementIndex, parentIndex } = props;
        props.updateElements(elements, elementIndex, parentIndex);
        return {};
    }
}

function collect(connect, monitor) {
    return {
        connectDropTarget: connect.dropTarget(),
        isOver: monitor.isOver(),
        isOverCurrent: monitor.isOver({ shallow: false }),
        canDrop: monitor.canDrop(),
        itemType: monitor.getItemType()
    }
}

const DragDropTarget = (props) => {
    const { connectDropTarget, dropArea, isOver, elementIndex, onHover, extraClassName } = props;

    useEffect(() => {
        if (isOver && onHover) onHover(elementIndex)
    }, [isOver])

    return connectDropTarget(
        <div className={`dropping-area${isOver ? " is-over" : ""}${extraClassName? " " + extraClassName : ""}`}>
            {dropArea}
        </div>
    )
}

export default DropTarget('element', target, collect)(DragDropTarget);